import React from 'react';
import IconCross from '../Icons/IconCross';
import './Content.scss';
import {
    Button
} from 'semantic-ui-react'

import { Link } from 'react-router-dom';

/*
<Link to={movie.url} ><Button onClick={movie}>Ver detalle</Button>  </Link> 
*/

const Content = ({ movie, onClose  }) => (
    
    
  <div className="contentnf">
    <div className="contentnf__background">
      <div className="contentnf__background__shadow" />
      <div
        className="contentnf__background__image"
        style={{ 'background-image': `url(${movie.image})` }}
      /> 
    </div>
    <div className="contentnf__area">
      <div className="contentnf__area__container">
        <div className="contentnf__title"><p>{movie.title}</p></div>
        <div className="contentnf__description">
          <p>{onClose}{movie.desc}</p>
        <Link to={movie.url} ><Button>Ver detalle</Button>  </Link> 
        </div>
      </div>
      <button className="contentnf__close" onClick={onClose}>
        <IconCross />
      </button>
    </div>
  </div>
);

export default Content;
